import { render } from "./ServiceClassification.vue?vue&type=template&id=38ac3c60&scoped=true"
import script from "./ServiceClassification.vue?vue&type=script&lang=js"
export * from "./ServiceClassification.vue?vue&type=script&lang=js"

import "./ServiceClassification.vue?vue&type=style&index=0&id=38ac3c60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38ac3c60"

export default script